var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"direction":"vertical"}},[_c('page-title',[_vm._v("Info")]),_c('pre',[_vm._v(_vm._s(_vm.location))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }